export default "__VITE_ASSET__DS$sTZ9n__"